import React, { useRef, useEffect, forwardRef, useState, useCallback, useImperativeHandle, Fragment } from 'react';
import PropTypes from 'prop-types';

var styles = {"tridi-viewer":"_lqEjs","tridi-draggable-true":"_2kfM8","tridi-recording-true":"_f-Ry5","tridi-viewer-image":"_2VqNg","tridi-viewer-image-shown":"_3zqPm","tridi-viewer-image-hidden":"_1WW7u","tridi-hint-overlay":"_3Ohj5","tridi-hint":"_1Wsta","tridi-hint-text":"_14UgB","tridi-loading":"_JdKYk","load8":"_IpOvS","fadeIn":"_3uImN"};

function useInterval(callback, delay) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var savedCallback = useRef();
  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(function () {
    function tick() {
      savedCallback.current.apply(savedCallback, args);
    }

    if (delay !== null && delay !== undefined) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }
  }, [delay]);
}

function useTridiKeyPressHandler(_ref) {
  var nextMove = _ref.nextMove,
      prevMove = _ref.prevMove;
  var refPrevMove = useRef();
  var refNextMove = useRef();
  useEffect(function () {
    refPrevMove.current = prevMove;
    refNextMove.current = nextMove;
  }, [nextMove, prevMove]);

  function downHandler(_ref2) {
  }

  var upHandler = function upHandler(_ref3) {
    var key = _ref3.key;
    var keyEventConfig = {
      ArrowLeft: refPrevMove,
      ArrowRight: refNextMove
    };
    var keyEventHandler = keyEventConfig[key];

    if (keyEventHandler) {
      keyEventHandler.current();
    }
  };

  useEffect(function () {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    return function () {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, []);
}

var styles$1 = {"tridi-control-bar":"_3jUN-","tridi-control-button":"_gReMg"};

var TargetIcon = function TargetIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16 7h-1.577A6.516 6.516 0 0 0 9 1.577V0H7v1.577A6.516 6.516 0 0 0 1.577 7H0v2h1.577A6.516 6.516 0 0 0 7 14.423V16h2v-1.577A6.516 6.516 0 0 0 14.423 9H16V7zm-3.612 0h-1.559A3.008 3.008 0 0 0 9 5.171V3.612A4.516 4.516 0 0 1 12.388 7zM8 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM7 3.612v1.559A3.008 3.008 0 0 0 5.171 7H3.612A4.516 4.516 0 0 1 7 3.612zM3.612 9h1.559A3.008 3.008 0 0 0 7 10.829v1.559A4.516 4.516 0 0 1 3.612 9zM9 12.388v-1.559A3.008 3.008 0 0 0 10.829 9h1.559A4.516 4.516 0 0 1 9 12.388z"
  }));
};

TargetIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 16 16"
};

var StopIcon = function StopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 14.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13zM5 5h6v6H5z"
  }));
};

StopIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 16 16"
};

var NextIcon = function NextIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 8L5 5v6zM11 5H9v6h2V5z"
  }));
};

NextIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 16 16"
};

var PrevIcon = function PrevIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 14.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8l4-3v6zM5 5h2v6H5V5z"
  }));
};

PrevIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 16 16"
};

var PauseIcon = function PauseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 14.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13zM5 5h2v6H5zm4 0h2v6H9z"
  }));
};

PauseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 16 16"
};

var PlayIcon = function PlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 14.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13zm-2-10L12 8l-6 3.5z"
  }));
};

PlayIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 16 16"
};

var ControlBar = function ControlBar(_ref) {
  var isPlaying = _ref.isPlaying,
      isRecording = _ref.isRecording,
      setIsPlaying = _ref.setIsPlaying,
      setIsRecording = _ref.setIsRecording,
      onPlay = _ref.onPlay,
      onPause = _ref.onPause,
      onNext = _ref.onNext,
      onPrev = _ref.onPrev,
      onRecordStart = _ref.onRecordStart,
      onRecordStop = _ref.onRecordStop;

  var playHandler = function playHandler() {
    setIsPlaying(true);
    onPlay();
  };

  var pauseHandler = function pauseHandler() {
    setIsPlaying(false);
    onPause();
  };

  var recordStartHandler = function recordStartHandler() {
    setIsRecording(true);
    onRecordStart();
  };

  var recordStopHandler = function recordStopHandler() {
    setIsRecording(false);
    onRecordStop();
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "tridi-control-bar " + styles$1['tridi-control-bar'],
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, !isRecording && /*#__PURE__*/React.createElement("a", {
    className: "" + styles$1['tridi-control-button'],
    onClick: recordStartHandler
  }, /*#__PURE__*/React.createElement(TargetIcon, null)), isRecording && /*#__PURE__*/React.createElement("a", {
    className: "" + styles$1['tridi-control-button'],
    onClick: recordStopHandler
  }, /*#__PURE__*/React.createElement(StopIcon, null)), !isPlaying && /*#__PURE__*/React.createElement("a", {
    className: "" + styles$1['tridi-control-button'],
    onClick: playHandler
  }, /*#__PURE__*/React.createElement(PlayIcon, null)), isPlaying && /*#__PURE__*/React.createElement("a", {
    className: "" + styles$1['tridi-control-button'],
    onClick: pauseHandler
  }, /*#__PURE__*/React.createElement(PauseIcon, null)), /*#__PURE__*/React.createElement("a", {
    className: "" + styles$1['tridi-control-button'],
    onClick: onPrev
  }, /*#__PURE__*/React.createElement(PrevIcon, null)), /*#__PURE__*/React.createElement("a", {
    className: "" + styles$1['tridi-control-button'],
    onClick: onNext
  }, /*#__PURE__*/React.createElement(NextIcon, null)));
};

var styles$2 = {"tridi-dot":"_1TrFD","tridi-pin":"_1QXU8"};

var Pins = function Pins(_ref) {
  var pins = _ref.pins,
      viewerWidth = _ref.viewerWidth,
      viewerHeight = _ref.viewerHeight,
      currentFrameId = _ref.currentFrameId,
      pinWidth = _ref.pinWidth,
      pinHeight = _ref.pinHeight,
      renderPin = _ref.renderPin,
      onPinDoubleClick = _ref.onPinDoubleClick,
      onPinClick = _ref.onPinClick;

  var getPosition = function getPosition(pin) {
    var left = viewerWidth * pin.x - pinWidth / 2;
    var top = viewerHeight * pin.y - pinHeight / 2;
    if (left < 0) left = 0;
    if (top < 0) top = 0;
    if (left >= 0 && top >= 0) return {
      left: left,
      top: top
    };
    return {
      display: 'none'
    };
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "tridi-dots-wrapper"
  }, (pins === null || pins === void 0 ? void 0 : pins.length) > 0 && pins.filter(function (pin) {
    return pin.frameId === currentFrameId;
  }).map(function (pin, index) {
    return renderPin ? /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "tridi-pin " + styles$2['tridi-pin'],
      style: getPosition(pin),
      onDoubleClick: function onDoubleClick(e) {
        e.stopPropagation();
        onPinDoubleClick(pin);
      },
      onClick: function onClick(e) {
        e.stopPropagation();
        onPinClick(pin);
      }
    }, renderPin(pin)) : /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "tridi-dot " + styles$2['tridi-dot'],
      style: getPosition(pin),
      onDoubleClick: function onDoubleClick(e) {
        e.stopPropagation();
        onPinDoubleClick(pin);
      },
      onClick: function onClick(e) {
        e.stopPropagation();
        onPinClick(pin);
      }
    });
  }));
};

Pins.defaultProps = {
  pins: [],
  pinWidth: 10,
  pinHeight: 10,
  onDoubleClick: function onDoubleClick() {},
  onPinClick: function onPinClick() {}
};

var styles$3 = {"tridi-status-bar":"_2_pZm"};

var StatusBar = function StatusBar(_ref) {
  var isRecording = _ref.isRecording,
      currentImageIndex = _ref.currentImageIndex;
  return /*#__PURE__*/React.createElement("div", {
    className: "tridi-status-bar " + styles$3['tridi-status-bar']
  }, /*#__PURE__*/React.createElement("div", {
    className: "status-info"
  }, /*#__PURE__*/React.createElement("span", {
    className: "info-label"
  }, "Frame Id: "), /*#__PURE__*/React.createElement("span", {
    className: "info-value"
  }, currentImageIndex)), isRecording && /*#__PURE__*/React.createElement("div", {
    className: "status-info"
  }, /*#__PURE__*/React.createElement("span", {
    className: "info-label"
  }, "Recording...")));
};

var TridiUtils = function TridiUtils() {};

TridiUtils.isValidProps = function (_ref2) {
  var images = _ref2.images,
      format = _ref2.format,
      location = _ref2.location;
  var isValid = true;

  if (!images && !format) {
    console.error("'format' property is missing or invalid. Image format must be provided for 'numbered' property.");
    isValid = false;
  }

  if (images === 'numbered' && !location) {
    console.error("'location' property is missing or invalid. Image location must be provided for 'numbered' property.");
    isValid = false;
  }

  return isValid;
};

TridiUtils.normalizedImages = function (images, format, location, count) {
  if (images === 'numbered') {
    return Array.apply(null, {
      length: count
    }).map(function (_a, index) {
      return location + "/" + (index + 1) + "." + format.toLowerCase();
    });
  }

  return images;
};

TridiUtils.uid = function () {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

var Tridi = forwardRef(function (_ref, ref) {
  var _viewerImageRef$curre, _viewerImageRef$curre2;

  var className = _ref.className,
      images = _ref.images,
      pins = _ref.pins,
      pinWidth = _ref.pinWidth,
      pinHeight = _ref.pinHeight,
      setPins = _ref.setPins,
      format = _ref.format,
      location = _ref.location,
      count = _ref.count,
      draggable = _ref.draggable,
      hintOnStartup = _ref.hintOnStartup,
      hintText = _ref.hintText,
      autoplay = _ref.autoplay,
      autoplaySpeed = _ref.autoplaySpeed,
      stopAutoplayOnClick = _ref.stopAutoplayOnClick,
      stopAutoplayOnMouseEnter = _ref.stopAutoplayOnMouseEnter,
      resumeAutoplayOnMouseLeave = _ref.resumeAutoplayOnMouseLeave,
      touch = _ref.touch,
      mousewheel = _ref.mousewheel,
      inverse = _ref.inverse,
      dragInterval = _ref.dragInterval,
      touchDragInterval = _ref.touchDragInterval,
      mouseleaveDetect = _ref.mouseleaveDetect,
      showControlBar = _ref.showControlBar,
      showStatusBar = _ref.showStatusBar,
      renderPin = _ref.renderPin,
      renderHint = _ref.renderHint,
      onHintHide = _ref.onHintHide,
      onAutoplayStart = _ref.onAutoplayStart,
      onAutoplayStop = _ref.onAutoplayStop,
      onNextMove = _ref.onNextMove,
      onPrevMove = _ref.onPrevMove,
      onNextFrame = _ref.onNextFrame,
      onPrevFrame = _ref.onPrevFrame,
      onDragStart = _ref.onDragStart,
      onDragEnd = _ref.onDragEnd,
      onFrameChange = _ref.onFrameChange,
      onRecordStart = _ref.onRecordStart,
      onRecordStop = _ref.onRecordStop,
      onPinClick = _ref.onPinClick;

  var _useState = useState([]),
      moveBuffer = _useState[0],
      setMoveBuffer = _useState[1];

  var _useState2 = useState(hintOnStartup),
      hintVisible = _useState2[0],
      setHintVisible = _useState2[1];

  var _useState3 = useState(0),
      currentImageIndex = _useState3[0],
      setCurrentImageIndex = _useState3[1];

  var _useState4 = useState(false),
      isDragging = _useState4[0],
      setIsDragging = _useState4[1];

  var _useState5 = useState(false),
      isAutoPlayRunning = _useState5[0],
      setIsAutoPlayRunning = _useState5[1];

  var _useState6 = useState(false),
      isRecording = _useState6[0],
      setIsRecording = _useState6[1];

  var _useState7 = useState(null),
      recordingSessionId = _useState7[0],
      setRecordingSessionId = _useState7[1];

  var _useState8 = useState(false),
      isPlaying = _useState8[0],
      setIsPlaying = _useState8[1];

  var _count = Array.isArray(images) ? images.length : Number(count);

  var _images = TridiUtils.normalizedImages(images, format, location, _count);

  var _viewerImageRef = useRef(null);

  var _draggable = !isRecording && draggable;

  var hideHint = function hideHint() {
    setHintVisible(false);
    onHintHide();
  };

  var nextFrame = useCallback(function () {
    var newIndex = currentImageIndex >= _count - 1 ? 0 : currentImageIndex + 1;
    setCurrentImageIndex(newIndex);
    onNextFrame();
    onFrameChange(newIndex);
  }, [_count, currentImageIndex, onFrameChange, onNextFrame]);
  var prevFrame = useCallback(function () {
    var newIndex = currentImageIndex <= 0 ? _count - 1 : currentImageIndex - 1;
    setCurrentImageIndex(newIndex);
    onPrevFrame();
    onFrameChange(newIndex);
  }, [_count, currentImageIndex, onFrameChange, onPrevFrame]);
  var nextMove = useCallback(function () {
    onNextMove();
    return inverse ? prevFrame() : nextFrame();
  }, [inverse, nextFrame, onNextMove, prevFrame]);
  var prevMove = useCallback(function () {
    onPrevMove();
    return inverse ? nextFrame() : prevFrame();
  }, [inverse, nextFrame, onPrevMove, prevFrame]);
  var rotateViewerImage = useCallback(function (e) {
    var interval = e.touches ? touchDragInterval : dragInterval;
    var eventX = e.touches ? Math.round(e.touches[0].clientX) : e.clientX;
    var coord = eventX - _viewerImageRef.current.offsetLeft;
    var newMoveBufffer = moveBuffer;

    if (moveBuffer.length < 2) {
      newMoveBufffer = moveBuffer.concat(coord);
    } else {
      newMoveBufffer = [moveBuffer[1], coord];
    }

    setMoveBuffer(newMoveBufffer);
    var threshold = !(coord % interval);
    var oldMove = newMoveBufffer[0];
    var newMove = newMoveBufffer[1];

    if (threshold && newMove < oldMove) {
      nextMove();
    } else if (threshold && newMove > oldMove) {
      prevMove();
    }
  }, [dragInterval, moveBuffer, nextMove, prevMove, touchDragInterval]);

  var resetMoveBuffer = function resetMoveBuffer() {
    return setMoveBuffer([]);
  };

  var startDragging = useCallback(function () {
    setIsDragging(true);
    onDragStart();
  }, [onDragStart]);
  var stopDragging = useCallback(function () {
    setIsDragging(false);
    onDragEnd();
  }, [onDragEnd]);

  var _toggleAutoplay = useCallback(function (state) {
    setIsAutoPlayRunning(state);
    return state ? onAutoplayStart() : onAutoplayStop();
  }, [onAutoplayStart, onAutoplayStop]);

  var _toggleRecording = function toggleRecording(state, existingSessionId) {
    setIsRecording(state);
    var sessionId = recordingSessionId || existingSessionId || TridiUtils.uid();

    if (state) {
      if (!recordingSessionId) {
        setRecordingSessionId(sessionId);
      }

      onRecordStart(sessionId);
    } else {
      setRecordingSessionId(null);
      onRecordStop(sessionId);
    }
  };

  var imageViewerMouseDownHandler = function imageViewerMouseDownHandler(e) {
    if (_draggable) {
      if (e.preventDefault) e.preventDefault();
      startDragging();
      rotateViewerImage(e);
    }

    if (isAutoPlayRunning && stopAutoplayOnClick) {
      _toggleAutoplay(false);
    }
  };

  var imageViewerMouseUpHandler = function imageViewerMouseUpHandler(e) {
    if (_draggable) {
      if (e.preventDefault) e.preventDefault();
      stopDragging();
      resetMoveBuffer();
    }
  };

  var imageViewerMouseMoveHandler = function imageViewerMouseMoveHandler(e) {
    if (_draggable && isDragging) {
      rotateViewerImage(e);
    }
  };

  var imageViewerMouseLeaveHandler = function imageViewerMouseLeaveHandler() {
    if (_draggable) resetMoveBuffer();

    if (!isAutoPlayRunning && resumeAutoplayOnMouseLeave) {
      _toggleAutoplay(true);
    }

    if (mouseleaveDetect) {
      stopDragging();
      resetMoveBuffer();
    }
  };

  var imageViewerMouseEnterHandler = function imageViewerMouseEnterHandler() {
    if (isAutoPlayRunning && stopAutoplayOnMouseEnter) {
      _toggleAutoplay(false);
    }
  };

  var imageViewerWheelHandler = useCallback(function (e) {
    if (mousewheel) {
      if (e.preventDefault) e.preventDefault();
      e.deltaY / 120 > 0 ? nextMove() : prevMove();
    }
  }, [mousewheel, nextMove, prevMove]);
  var imageViewerTouchStartHandler = useCallback(function (e) {
    if (touch) {
      if (e.preventDefault) e.preventDefault();
      startDragging();
      rotateViewerImage(e);
    }

    if (isAutoPlayRunning && stopAutoplayOnClick) {
      _toggleAutoplay(false);
    }
  }, [isAutoPlayRunning, rotateViewerImage, startDragging, stopAutoplayOnClick, _toggleAutoplay, touch]);
  var imageViewerTouchMoveHandler = useCallback(function (e) {
    if (touch) {
      if (e.preventDefault) e.preventDefault();
      rotateViewerImage(e);
    }
  }, [rotateViewerImage, touch]);
  var imageViewerTouchEndHandler = useCallback(function (e) {
    if (touch) {
      stopDragging();
      resetMoveBuffer();
    }

    if (!isAutoPlayRunning && resumeAutoplayOnMouseLeave) {
      _toggleAutoplay(true);
    }
  }, [isAutoPlayRunning, resumeAutoplayOnMouseLeave, stopDragging, _toggleAutoplay, touch]);

  var imageViewerClickHandler = function imageViewerClickHandler(e) {
    if (isRecording) {
      var clientX = e.clientX;
      var clientY = e.clientY;
      var viewerWidth = _viewerImageRef.current.clientWidth;
      var viewerHeight = _viewerImageRef.current.clientHeight;

      var viewerOffsetLeft = _viewerImageRef.current.getBoundingClientRect().left;

      var viewerOffsetTop = _viewerImageRef.current.getBoundingClientRect().top;

      var x = ((clientX - viewerOffsetLeft) / viewerWidth).toFixed(6);
      var y = ((clientY - viewerOffsetTop) / viewerHeight).toFixed(6);
      var pin = {
        id: TridiUtils.uid(),
        frameId: currentImageIndex,
        x: x,
        y: y,
        recordingSessionId: recordingSessionId
      };
      var newPins = pins.concat(pin);
      setPins(newPins);
    }
  };

  var pinDoubleClickHandler = function pinDoubleClickHandler(pin) {
    if (isRecording) {
      var newPins = pins.filter(function (item) {
        return item.id !== pin.id;
      });
      setPins(newPins);
    }
  };

  var pinClickHandler = function pinClickHandler(pin) {
    if (!isRecording) {
      onPinClick(pin);
    }
  };

  useEffect(function () {
    var viewerRef = _viewerImageRef.current;
    viewerRef.addEventListener('touchstart', imageViewerTouchStartHandler, {
      passive: false
    });
    viewerRef.addEventListener('touchmove', imageViewerTouchMoveHandler, {
      passive: false
    });
    viewerRef.addEventListener('touchend', imageViewerTouchEndHandler, {
      passive: false
    });
    viewerRef.addEventListener('wheel', imageViewerWheelHandler, {
      passive: false
    });
    return function () {
      viewerRef.removeEventListener('touchstart', imageViewerTouchStartHandler);
      viewerRef.removeEventListener('touchmove', imageViewerTouchMoveHandler);
      viewerRef.removeEventListener('touchend', imageViewerTouchEndHandler);
      viewerRef.removeEventListener('wheel', imageViewerWheelHandler);
    };
  }, [imageViewerTouchEndHandler, imageViewerTouchMoveHandler, imageViewerTouchStartHandler, imageViewerWheelHandler]);
  useEffect(function () {
    if (autoplay) {
      _toggleAutoplay(autoplay);
    }
  }, [autoplay, _toggleAutoplay]);
  useInterval(function () {
    nextMove();
  }, isAutoPlayRunning ? autoplaySpeed : null);
  useImperativeHandle(ref, function () {
    return {
      toggleRecording: function toggleRecording(state, recordingSessionId) {
        return _toggleRecording(state, recordingSessionId);
      },
      toggleAutoplay: function toggleAutoplay(state) {
        return _toggleAutoplay(state);
      },
      next: function next() {
        return nextMove();
      },
      prev: function prev() {
        return prevMove();
      }
    };
  });
  useTridiKeyPressHandler({
    nextMove: nextMove,
    prevMove: prevMove
  });

  var renderImages = function renderImages() {
    return _images.map(function (src, index) {
      return /*#__PURE__*/React.createElement("img", {
        key: index,
        src: src,
        className: styles['tridi-viewer-image'] + " " + (currentImageIndex === index ? styles['tridi-viewer-image-shown'] : styles['tridi-viewer-image-hidden']),
        alt: ""
      });
    });
  };

  var renderHintOverlay = function renderHintOverlay() {
    return /*#__PURE__*/React.createElement("div", {
      className: "" + styles['tridi-hint-overlay'],
      onClick: hideHint,
      onTouchStart: hideHint
    }, !renderHint && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "" + styles['tridi-hint']
    }), hintText && /*#__PURE__*/React.createElement("span", {
      className: "" + styles['tridi-hint-text']
    }, hintText)), renderHint && renderHint());
  };

  var generateViewerClassName = function generateViewerClassName() {
    var classNameStr = styles['tridi-viewer'];
    if (_draggable) classNameStr += ' ' + styles['tridi-draggable-true'];
    if (isRecording) classNameStr += ' ' + styles['tridi-recording-true'];
    if (touch) classNameStr += ' ' + styles['tridi-touch-true'];
    if (mousewheel) classNameStr += ' ' + styles['tridi-mousewheel-true'];
    if (hintOnStartup) classNameStr += ' ' + styles['tridi-hintOnStartup-true'];
    if (className) classNameStr += ' ' + className;
    return classNameStr;
  };

  if (!TridiUtils.isValidProps({
    images: images,
    format: format,
    location: location
  })) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: generateViewerClassName()
  }, hintVisible && renderHintOverlay(), /*#__PURE__*/React.createElement("div", {
    ref: _viewerImageRef,
    onMouseDown: imageViewerMouseDownHandler,
    onMouseUp: imageViewerMouseUpHandler,
    onMouseMove: imageViewerMouseMoveHandler,
    onMouseLeave: imageViewerMouseLeaveHandler,
    onMouseEnter: imageViewerMouseEnterHandler,
    onClick: imageViewerClickHandler,
    style: {
      width: '100%'
    }
  }, (_images === null || _images === void 0 ? void 0 : _images.length) > 0 && renderImages()), showStatusBar && /*#__PURE__*/React.createElement(StatusBar, {
    isRecording: isRecording,
    currentImageIndex: currentImageIndex
  }), showControlBar && /*#__PURE__*/React.createElement(ControlBar, {
    isPlaying: isPlaying,
    isRecording: isRecording,
    setIsPlaying: setIsPlaying,
    setIsRecording: setIsRecording,
    onPlay: function onPlay() {
      return _toggleAutoplay(true);
    },
    onPause: function onPause() {
      return _toggleAutoplay(false);
    },
    onNext: function onNext() {
      return nextMove();
    },
    onPrev: function onPrev() {
      return prevMove();
    },
    onRecordStart: function onRecordStart() {
      return _toggleRecording(true);
    },
    onRecordStop: function onRecordStop() {
      return _toggleRecording(false);
    }
  }), /*#__PURE__*/React.createElement(Pins, {
    pins: pins,
    viewerWidth: _viewerImageRef === null || _viewerImageRef === void 0 ? void 0 : (_viewerImageRef$curre = _viewerImageRef.current) === null || _viewerImageRef$curre === void 0 ? void 0 : _viewerImageRef$curre.clientWidth,
    viewerHeight: _viewerImageRef === null || _viewerImageRef === void 0 ? void 0 : (_viewerImageRef$curre2 = _viewerImageRef.current) === null || _viewerImageRef$curre2 === void 0 ? void 0 : _viewerImageRef$curre2.clientHeight,
    currentFrameId: currentImageIndex,
    pinWidth: pinWidth,
    pinHeight: pinHeight,
    onPinDoubleClick: pinDoubleClickHandler,
    onPinClick: pinClickHandler,
    renderPin: renderPin
  }));
});
Tridi.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  images: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  pins: PropTypes.array,
  pinWidth: PropTypes.number,
  pinHeight: PropTypes.number,
  format: PropTypes.string,
  location: PropTypes.string,
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  draggable: PropTypes.bool,
  hintOnStartup: PropTypes.bool,
  hintText: PropTypes.string,
  autoplay: PropTypes.bool,
  autoplaySpeed: PropTypes.number,
  stopAutoplayOnClick: PropTypes.bool,
  stopAutoplayOnMouseEnter: PropTypes.bool,
  resumeAutoplayOnMouseLeave: PropTypes.bool,
  touch: PropTypes.bool,
  mousewheel: PropTypes.bool,
  inverse: PropTypes.bool,
  dragInterval: PropTypes.number,
  touchDragInterval: PropTypes.number,
  mouseleaveDetect: PropTypes.bool,
  showControlBar: PropTypes.bool,
  showStatusBar: PropTypes.bool,
  renderPin: PropTypes.func,
  setPins: PropTypes.func,
  renderHint: PropTypes.func,
  onHintHide: PropTypes.func,
  onAutoplayStart: PropTypes.func,
  onAutoplayStop: PropTypes.func,
  onNextMove: PropTypes.func,
  onPrevMove: PropTypes.func,
  onNextFrame: PropTypes.func,
  onPrevFrame: PropTypes.func,
  onDragStart: PropTypes.func,
  onDragEnd: PropTypes.func,
  onFrameChange: PropTypes.func,
  onRecordStart: PropTypes.func,
  onRecordStop: PropTypes.func,
  onPinClick: PropTypes.func
};
Tridi.defaultProps = {
  className: undefined,
  style: undefined,
  images: 'numbered',
  pin: undefined,
  pinWidth: 10,
  pinHeight: 10,
  format: undefined,
  location: './images',
  count: undefined,
  draggable: true,
  hintOnStartup: false,
  hintText: null,
  autoplay: false,
  autoplaySpeed: 50,
  stopAutoplayOnClick: false,
  stopAutoplayOnMouseEnter: false,
  resumeAutoplayOnMouseLeave: false,
  touch: true,
  mousewheel: false,
  inverse: false,
  dragInterval: 1,
  touchDragInterval: 2,
  mouseleaveDetect: false,
  showControlBar: false,
  showStatusBar: false,
  renderPin: undefined,
  setPins: function setPins() {},
  renderHint: undefined,
  onHintHide: function onHintHide() {},
  onAutoplayStart: function onAutoplayStart() {},
  onAutoplayStop: function onAutoplayStop() {},
  onNextMove: function onNextMove() {},
  onPrevMove: function onPrevMove() {},
  onNextFrame: function onNextFrame() {},
  onPrevFrame: function onPrevFrame() {},
  onDragStart: function onDragStart() {},
  onDragEnd: function onDragEnd() {},
  onFrameChange: function onFrameChange() {},
  onRecordStart: function onRecordStart() {},
  onRecordStop: function onRecordStop() {},
  onPinClick: function onPinClick() {}
};

export default Tridi;
//# sourceMappingURL=index.modern.js.map
